import UserSearchHome from "./UserSearchHome";
import UserSearchResults from "./UserSearchResults";
import { useStore } from "../../redux/Store";

const MainContent = () => {
  const store = useStore();
  return(
      <div> 
        {store.state.searchTerms.showResults ?  <UserSearchResults /> : <UserSearchHome />}
      </div>
    )
}

export default MainContent;
